import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { CurrentDirectionContextProviderToggle } from '../../../../utils/dimensions';
export var TableBodyRowContent = function () { return (React.createElement(React.Fragment, null,
    React.createElement(RampWithNameTransform, { rampName: "BodyRowHeadingBase" }),
    React.createElement(CurrentDirectionContextProviderToggle, null,
        React.createElement(RampWithNameTransform, { rampName: "BodyRowMapper" })))); };
